import SettingsWelcome from 'trunks/vue/admin/components/settings/settings_container/settings_welcome.js'

export default {
  welcome() {
    this._generateSettingsSidebarView('settings__welcome')
    Skylark.Libs.Ajax.get('/admin/settings/welcome.json', {
      responseType: 'json',
      success: (data) => {
        new SettingsWelcome({
          el: DomMaster.find('#js-settings-welcome').node,
          propsData: {
            activeTab: 'welcome',
            welcomeData: data
          }
        })
      }
    })
  }
}
